import styles from './CurrentMemberInfo.module.css'
import { Avatar } from '@/components/Avatar'

export interface CurrentMemberInfoProps {
  avatar: string | null | undefined
  displayName: string | undefined
  online: boolean
  subtitle: string
}

export function CurrentMemberInfo({
  avatar,
  displayName,
  online,
  subtitle,
}: CurrentMemberInfoProps) {
  return (
    <div className={styles.memberInfo}>
      <div className={styles.avatarContainer}>
        <Avatar
          badge={online ? 'online' : 'offline'}
          size={40}
          subject={{
            avatar,
            displayName,
          }}
        />
      </div>
      <div className={styles.memberContent}>
        <strong className={styles.memberTitle}>{displayName}</strong>
        <p className={styles.memberSubtitle}>{subtitle}</p>
      </div>
    </div>
  )
}
